import { render, staticRenderFns } from "./MypageUserInitConfirmPane.vue?vue&type=template&id=7b8bbdfe&scoped=true"
import script from "./MypageUserInitConfirmPane.vue?vue&type=script&lang=ts"
export * from "./MypageUserInitConfirmPane.vue?vue&type=script&lang=ts"
import style0 from "./MypageUserInitConfirmPane.vue?vue&type=style&index=0&id=7b8bbdfe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8bbdfe",
  null
  
)

export default component.exports